import type { NsDict } from '../ru';

export const app: NsDict<'app'> = {
  brand: 'Market Table',
  signingIn: 'Signing in…',
  activeGame: 'Your game is in progress',
  seated: 'You are seated at a table',
  backToTable: 'Back to the table',
  'nav.label': 'Sections',
  'nav.admin': 'Administration',
  'nav.lobby': 'Games',
  'nav.profile': 'Profile',
  demo: 'DEMO',
  demoMore: '· play credits · no real money',
  demoTitle: 'Play credits have no monetary value',
  rules: 'Rules',
  theme: 'Switch theme',
  balanceTitle: 'Play credit balance',
  'menu.profile': 'Profile and history',
  'menu.logout': 'Sign out',
  'conn.connecting': 'Connecting to the server…',
  'conn.lost': 'No connection to the server — reconnecting…',
  'conn.poll': 'fallback HTTP channel',
  'conn.code': '(code {code})',
  'conn.attempts': ', attempts: {n}.',
  'conn.wsHint': 'If WebSocket is unavailable on your network, the client will switch to the fallback channel automatically.',
  'conn.pollHint': 'The server is unreachable over HTTP as well — check your network connection.',
  noConnection: 'no connection to the server — reconnecting',
  'api.offline': 'no connection to the server',
  'api.serverError': 'server error ({status})',
};
